export const textColor = '#00211C';
